const BudResLinesColumns = [
    { headerName: 'Charge Type', field: 'chargeType' },
    { headerName: 'Brand', field: 'brand' },
    { headerName: 'Charge Period', field: 'chargePeriod' },
    { headerName: 'Document Date', field: 'docDate' },
    { headerName: 'Country Code', field: 'countryCode' },
    { headerName: 'Station Name', field: 'stName' },
    { headerName: 'Station Number', field: 'stNumber' },
    { headerName: 'Customer No.', field: 'custNo' },
    { headerName: 'Licensee Customer No.', field: 'licCustNo' },
    { headerName: 'Pickup Text', field: 'pickUpText' },
    { headerName: 'Pickup Date', field: 'pickUpDate' },
    { headerName: 'Renter Name', field: 'rentName' },
    { headerName: 'Reservation Number', field: 'resNo' },
    { headerName: 'ResCTR', field: 'resCTR' },
    { headerName: 'CL Indicator', field: 'clInd' },
    { headerName: 'Station Indicator', field: 'stationInd' },
    { headerName: 'Rental Days', field: 'rentDays' },
    { headerName: 'Description', field: 'desc' },
    { headerName: 'Source', field: 'source' },
    { headerName: 'Currency', field: 'curr' },
    { headerName: 'Unit Price', field: 'unitPrice' },
    { headerName: 'Source Code', field: 'sourceCode' },
    { headerName: 'Charge Code1', field: 'chargeCode1' },
    { headerName: 'Charge Code2', field: 'chargeCode2' }
];

  export default BudResLinesColumns;  